module.exports = __webpack_public_path__ + "static/media/hemoglobin-bottom.6b0b13c0.png";